export const EmailSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M12 13.5L2 6.75V18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6.75L12 13.5zm0-2.5L22 6H2l10 5z" />
    </svg>
  );
};

export const GithubSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M12 2C6.48 2 2 6.48 2 12c0 4.41 2.87 8.15 6.84 9.48.5.09.68-.22.68-.48v-1.7c-2.78.61-3.37-1.34-3.37-1.34-.45-1.14-1.11-1.45-1.11-1.45-.91-.62.07-.6.07-.6 1 .07 1.52 1.03 1.52 1.03.89 1.52 2.34 1.08 2.91.83.09-.64.35-1.08.63-1.33-2.22-.25-4.55-1.11-4.55-4.93 0-1.09.39-1.98 1.03-2.68-.1-.26-.45-1.29.1-2.69 0 0 .84-.27 2.75 1.03a9.57 9.57 0 015 0c1.91-1.3 2.75-1.03 2.75-1.03.55 1.4.2 2.43.1 2.69.64.7 1.03 1.59 1.03 2.68 0 3.83-2.33 4.68-4.55 4.93.36.31.68.93.68 1.87v2.78c0 .26.18.57.68.48A10 10 0 0022 12c0-5.52-4.48-10-10-10z" />
    </svg>
  );
};

export const LinkedInSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M19 3A2 2 0 0121 5v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14zm-8.5 7.5h-3V18h3v-7.5zm-1.5-4a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm11 11h-3v-3.5c0-.97-.78-1.75-1.75-1.75S13 13.03 13 14v4h-3v-7.5h3v1.11c.65-.7 1.61-1.11 2.63-1.11A3.75 3.75 0 0119 14.75V18z" />
    </svg>
  );
};

export const FacebookSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8v-6.93H7.9v-2.87H10V9.91c0-2.07 1.26-3.21 3.13-3.21.9 0 1.84.16 1.84.16v2.02h-1.04c-1.03 0-1.35.64-1.35 1.3v1.56h2.3l-.37 2.87h-1.93v6.93c4.56-.93 8-4.96 8-9.8z" />
    </svg>
  );
};

export const TwitterSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M22.46 6c-.77.35-1.6.58-2.46.69.89-.53 1.57-1.37 1.89-2.37-.83.5-1.75.87-2.73 1.07A4.27 4.27 0 0016.5 4c-2.36 0-4.27 1.91-4.27 4.27 0 .33.03.65.1.96C8.07 8.94 5.17 7.4 3.11 5.07a4.26 4.26 0 00-.58 2.15c0 1.48.76 2.78 1.91 3.55-.7-.02-1.37-.21-1.95-.54v.05c0 2.06 1.47 3.78 3.41 4.17-.36.1-.74.15-1.13.15-.28 0-.55-.03-.82-.08.56 1.73 2.17 2.99 4.09 3.03a8.57 8.57 0 01-5.31 1.83c-.34 0-.67-.02-1-.06a12.08 12.08 0 006.52 1.91c7.83 0 12.11-6.48 12.11-12.11l-.01-.55A8.72 8.72 0 0024 5.5a8.43 8.43 0 01-2.54.7z" />
    </svg>
  );
};

export const TelegramSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.89 7.67l-1.82 8.56c-.14.64-.54.8-1.1.5l-3.07-2.27-1.48 1.43c-.17.18-.3.33-.61.33l.22-3.12 5.67-5.1c.25-.22-.05-.34-.39-.12l-7.02 4.42-3.02-.94c-.66-.2-.67-.66.14-.98l11.8-4.55c.55-.2 1.03.12.85.95z" />
    </svg>
  );
};

export const MobilePhoneSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M7 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H7zm0 2h10v16H7V4zm5 14c.83 0 1.5-.67 1.5-1.5S12.83 15 12 15s-1.5.67-1.5 1.5S11.17 18 12 18z" />
    </svg>
  );
};

export const SkypeSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10-10-4.48-10-10S6.48 2 12 2zm-.17 15c2.96 0 4.53-1.48 4.53-3.1 0-1.36-.78-2.24-2.56-2.74l-1.7-.45c-.52-.13-.8-.3-.8-.62 0-.4.42-.63 1.03-.63.93 0 1.45.34 1.45.88h2.26c-.05-1.56-1.33-2.72-3.38-2.91V7h-1.62v.91c-2.24.3-3.5 1.51-3.5 3.09 0 1.36.86 2.32 2.42 2.74l1.7.45c.57.15.85.3.85.63 0 .35-.4.62-1.14.62-.95 0-1.58-.35-1.58-.92H7.83c.06 1.68 1.43 2.83 3.55 2.98V17h1.45v-.02c.01.02.03.02.03.02z" />
    </svg>
  );
};
